import oneSipApiCall from "../apiCall.js"

const eventHost={
  listEventHosts({commit,state},{router}){
    return oneSipApiCall(commit,state,router,'/list-all-event-host')
  },
}

export default eventHost;